import type { MARKETING_SESSION_TYPES } from "@pollen/core/model/course-session.model";
import type { I18nMessage } from "@pollen/core/model/i18n.model";

type EventTypeDefinition = {
  label: I18nMessage;
  icon: string;
  color: string;
};

const registry: Record<
  (typeof MARKETING_SESSION_TYPES)[number],
  EventTypeDefinition
> = {
  MASTER_SESSION: {
    label: "Master session",
    icon: "ph:crown-duotone",
    color: "#ffe24e",
  },
  WEBINAR: {
    label: "Webinar",
    icon: "ph:video-duotone",
    color: "#50228F",
  },
  INTER: {
    label: "Formation",
    icon: "ph:ticket-duotone",
    color: "#ff4dc2",
  },
  LUNCH: {
    label: "Déjeuner",
    icon: "ph:bowl-food",
    color: "#33d0fd",
  },
  BREAKFAST: {
    label: "Petit-déjeuner",
    icon: "ph:coffee",
    color: "#33d0fd",
  },
};

export function useEventType(type?: string | null): EventTypeDefinition {
  return registry[type as keyof typeof registry] ?? registry.INTER;
}
